<template>
  <div class="shop-container">
    <section class="section py-0">
      <div class="container">
        <h2 class="title is-3 has-text-centered mb-3">
          {{ $t("online store") }}
        </h2>
      </div>
    </section>

    <product-list ref="product_list" @toggle_cart="toggle_cart" />
    <cart ref="cart" @payment="payment" @cart_updated="cart_updated" />
    <payment-modal ref="payment_modal" @order_made="order_made" />
    <confirm-order-modal ref="confirm_order" @closed="confirmation_closed" />
  </div>
</template>

<script>
import ProductList from "./ProductList.vue";
import Cart from "./Cart.vue";
import PaymentModal from "./PaymentModal.vue";
import ConfirmOrderModal from "./ConfirmOrderModal.vue";
// import "animate.css";

export default {
  name: "OnlineStore",
  components: {
    ProductList,
    Cart,
    PaymentModal,
    ConfirmOrderModal,
  },
  data() {
    return {};
  },
  methods: {
    toggle_cart(cart_items) {
      let v = this;
      v.$refs.cart.toggle_cart(cart_items);
    },
    payment(cart_items) {
      let v = this;
      v.$refs.payment_modal.show(cart_items);
    },
    cart_updated(cart_items) {
      let v = this;
      v.$refs.product_list.set_cart_items(cart_items);
    },
    order_made(order) {
      let v = this;
      v.$refs.confirm_order.show(order);
    },
    confirmation_closed() {
      let v = this;
      v.$refs.product_list.set_cart_items([]);
      v.$refs.payment_modal.set_initial_state();
    },
  },
  computed: {},
};
</script>

<style scoped></style>
